import { getAttributeValue } from '@boc/framework/products/attributes';
import type {
  ProductCardFragment,
  ProductDetailsFragment,
} from '@boc/framework/saleor-graphql';

import { getPuzzleArtist, getPuzzlePieces, getPuzzleSeries } from '~/local/products/attributes';

export const DEFAULT_TITLE =
  'At Jigsaw Nation, we love puzzles. Our goal is to make puzzles so pretty that you want to frame them!';

export const genProductTitle = (product: ProductDetailsFragment | ProductCardFragment) => {
  const productTypeSlug = product.productType?.slug;

  switch (productTypeSlug) {
    case 'jigsaw-puzzle':
      return genJigsawPuzzleTitle(product);
    default:
      return product.name;
  }
};

const isForKids = (product: ProductDetailsFragment | ProductCardFragment) => {
  return product.collections?.map((collection) => collection.name).includes('Great for Kids');
};

const genJigsawPuzzleTitle = (product: ProductDetailsFragment | ProductCardFragment) => {
  const pieces = getPuzzlePieces(product);
  const artist = getPuzzleArtist(product);
  const series = getPuzzleSeries(product);

  let name = product.name;

  name = `${name} - A ${pieces ? `${pieces} Piece` : ''}${isForKids(product) ? ' Kids' : ''}${series ? ` ${series}` : ''} Jigsaw Puzzle${artist ? ` by ${artist}` : ''}`;

  return name;
};

export const genProductCategoryTitle = (product: ProductDetailsFragment | ProductCardFragment) => {
  switch (product.productType.slug) {
    case 'jigsaw-puzzle':
      const pieces = getAttributeValue(
        product.attributes,
        'puzzle-pieces',
        (pieces) => `${pieces} Piece`
      );
      return pieces
        ? `${pieces}${isForKids(product) ? ' Kids' : ''} Jigsaw Puzzle`
        : 'Jigsaw Puzzle';
    default:
      return product.category?.name;
  }
};
